var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 149,
    viewBox: "0 0 296 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_2140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.1426 152.311H82.9023V90.2764H85.1426V152.311ZM21.2861 150.121H19.0459V120.993H21.2861V150.121ZM33.6094 150.121H31.3691V112.031H33.6094V150.121ZM8.96289 149H6.72266V128.835H8.96289V149ZM45.9326 149H43.6924V104.188H45.9326V149ZM58.2559 147.88H56.0156V99.707H58.2559V147.88ZM70.5791 147.88H68.3389V86.2637H70.5791V147.88Z",
    fill: "url(#paint0_linear_65_2140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.199 48.1729H175.408V166.925H173.168V84.1182L170.958 84.9912V29.1279H173.199V48.1729ZM185.522 53.7744H187.731V161.323H185.491V79.2568L183.281 80.1289V22.4062H185.522V53.7744ZM197.846 60.4961H200.055V161.323H197.814V80.3818L195.604 79.457V15.124H197.846V60.4961ZM210.169 64.9775H212.378V157.963H210.138V155.722H207.928V149H210.138V85.54L207.928 84.6152L207.929 8.40234H210.169V64.9775ZM121.658 156.705L119.424 156.869V121.185L121.658 121.021V156.705ZM99.2588 155.722H97.0186V70.5791H99.2588V155.722ZM111.615 155.41H109.375V154.506H107.157V111.686H109.375V63.2969H111.615V155.41ZM97.0176 154.506H94.7773V104H97.0176V154.506ZM123.905 149H121.665V56.5752H123.905V149ZM136.229 149H133.988V49.8535H136.229L136.229 149ZM148.552 93.8301L146.312 94.7148V43.1318H148.553L148.552 93.8301ZM161.517 88.7158L159.276 89.5996V35.8496H161.517V88.7158Z",
    fill: "url(#paint1_linear_65_2140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.074 166.925H269.152V91.8643H273.074V166.925ZM286.038 166.925H282.116V98.5869H286.038V166.925ZM249.068 161.323H245.146V80.6611H249.068V161.323ZM261.392 161.323H257.47V86.2627H261.392V161.323ZM237.865 76.1807V157.963L233.943 157.962V76.1797L237.865 76.1807ZM225.262 70.5791V156.842H221.341V70.5791H225.262Z",
    fill: "url(#paint2_linear_65_2140)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_65_2140",
    x1: 71.0791,
    y1: 112.5,
    x2: 71.0791,
    y2: 147.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCA08A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947115,
    stopColor: "#BCA08A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_65_2140",
    x1: -21877,
    y1: 67.6857,
    x2: -21877,
    y2: 157.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.307692,
    stopColor: "#BCA08A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860577,
    stopColor: "#BCA08A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_65_2140",
    x1: -21090.9,
    y1: 64.9027,
    x2: -21090.9,
    y2: 156.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BCA08A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899038,
    stopColor: "#BCA08A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_2140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295.759,
    height: 149,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldIcon);
export default __webpack_public_path__ + "static/media/GoldIcon.b5edd36d9e0787cce134fa06b5e3fdfb.svg";
export { ForwardRef as ReactComponent };